var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"echarts-wrapper"},[(_vm.domName)?[_c('div',{key:("province-" + _vm.domName),staticClass:"canvas-box",attrs:{"id":_vm.domName}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }